import { useEffect, useState } from "react";
import { debounce, isEqual } from "lodash";
import { connect, FormikValues } from "formik";
import { AllFilterTypes } from "Types";

type OnChangeHandlerProps = {
    formik?: FormikValues;
    handleChange: (values: AllFilterTypes) => void;
    handleLoading: (state: boolean) => void;
};

const OnChangeHandler = <TFilter>({ formik, handleChange, handleLoading }: OnChangeHandlerProps): null => {
    const [lastValues, setLastValues] = useState(null);

    const save = debounce(() => {
        Promise.resolve(handleChange(formik?.values)).then(() => {
            setLastValues(formik?.values);
        });
    }, 300);

    const { values, isValid } = formik ? formik : { values: {}, isValid: false };

    useEffect(() => {
        if (!isValid || isEqual(lastValues, values)) {
            return;
        }
        handleLoading(true);
        save();

        return (): void => {
            save.cancel();
        };
    }, [values, isValid, lastValues, handleLoading, save]);

    return null;
};

export default connect(OnChangeHandler);
